import React, { Component } from 'react';
import '../../index.css';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
import config from '../../config';
import funciones from '../../middleware/funciones';

class Usuarios extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/users/', datasend).then(response => response.json())
            .then(data => {
                data = data.data;
                this.setState({ data })
            });
    }

    render() {
        const dato = (this.state.data) ? this.state.data : [];
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        return (
            <div className="contenedor">

                <Jumbotron className="Jumbotron">
                    <h2>Modulo Usuarios</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <Button className="plus" size="sm" href="/usuarios/crear/" variant="outline-primary">Crear Usuario</Button>
                        <Table hover bordered responsive size="sm" className="table">
                            <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th>Nombre</th>
                                    <th>Usuario</th>
                                    <th>Tipo Usuario</th>
                                    <th>Estado</th>
                                    <th>Ultima Modificacion</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>

                                {dato.map(function (currentData, index) {
                                    return <tr key={index + "d0"}>
                                        <td key={index + "d2"}>{currentData.ID_EMPRESA}</td>
                                        <td key={index + "d4"}>{currentData.NOMBRE_COMPLETO}</td>
                                        <td key={index + "d5"}>{currentData.USUARIO}</td>
                                        <td key={index + "d7"}>{(currentData.TIPO_USUARIO === '1') ? 'Administrador' : 'Gestor'}</td>
                                        <td key={index + "d8"}>{(currentData.ESTADO === '1') ? 'Activo' : 'Inactivo'}</td>
                                        <td key={index + "d10"}>{funciones.formatDate(currentData.UPDATE_AT)}</td>
                                        <td key={index + "d11"}><Button size="sm" href={"/usuarios/crear/?" + currentData.ID_USUARIO} variant="outline-primary">Editar</Button></td>
                                    </tr>;
                                })}
                            </tbody>
                        </Table>
                    </div>
                }
            </div>
        );
    }
}
export default (Usuarios);


// WEBPACK FOOTER //
// ./src/components/configuracion/usuarios.jsx